import { z } from 'zod'

import { languages, salutations } from '@/features/auth'

export const PersonalFormSchema = z.object({
  salutation: z
    .enum(salutations)
    .nullish()
    .transform((data) => data ?? undefined),
  title: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  firstName: z.string(),
  lastName: z.string(),
  phoneLandline: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  phoneMobile: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  languages: z.array(z.enum(languages)),
})

export type PersonalFormSchemaType = z.infer<typeof PersonalFormSchema>
